import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles/index';
import classNames from 'classnames';
import {Tabs, Tab, Icon, IconButton, Typography, Avatar, MenuItem, ListItemText, ListItemAvatar, LinearProgress, Dialog, DialogContent, CircularProgress, Menu, Button, ListItem, Badge, DialogActions} from '@material-ui/core';
import {connect} from 'react-redux';
import * as quickPanelActions from 'main/quickPanel/store/actions';
import {bindActionCreators} from 'redux';
import * as Actions from 'store/actions';
import * as AuthActions from 'auth/store/actions';
import BadgeAward from './badgeAward';
import _ from '@lodash';
import history from '../history';

import HomeIcon from '@material-ui/icons/Home';
import NotificationsIcon from '@material-ui/icons/Notifications';
import BallotIcon from '@material-ui/icons/Ballot';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import ContactsIcon from '@material-ui/icons/Contacts';
import AutorenewIcon from '@material-ui/icons/ClassRounded';

const styles = theme => ({
    root     : {
        display   : 'flex',
        alignItems: 'center',
        width     : '100%',
        height    : 50
    },
    seperator: {
        width          : 1,
        height         : 50,
        backgroundColor: theme.palette.divider
    },
    tabRoot: {
        fontSize: '8px',
        minHeight: 0,
        paddingTop: 12
    }
});

const StyledBadge = withStyles(theme => ({
    badge: {
      top: '10%',
      right: -3,
      // The border color match the background color.
      border: `1px solid ${
        theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[900]
      }`,
    },
  }))(Badge);

// const StyledBadgeKecil = withStyles(theme => ({
//     badge: {
//       top: '0%',
//       right: -3,
//       // The border color match the background color.
//       border: `1px solid ${
//         theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[900]
//       }`,
//     },
// }))(Badge);

class MainToolbar extends Component {

    state = {
        namaPengguna: null,
        email: null,
        tahun: localStorage.getItem('tahun'),
        routeParams: {
            tingkat_instrumen_id: 1,
            tahun: localStorage.getItem('tahun'),
            // token: localStorage.getItem('jwt_token'),
            // sekolah_id: JSON.parse( localStorage.getItem('user') ).sekolah_id,
            token: localStorage.getItem('jwt_token'),
            limit: 5
        },
        tabValue: window.location.pathname.split('/')[1],
        openNotifikasi: false,
        blocking_login: false
    }

    onChangeTahun = (event) => {
        this.setState({
            ...this.state,
            tahun: event.target.value,
            routeParams: {
                ...this.state.routeParams,
                tahun: event.target.value
            }
        },()=>{
            localStorage.setItem('tahun', event.target.value);

            this.props.getPlainKuesioner(this.state.routeParams).then((result)=>{
                localStorage.setItem('instrumen_id', this.props.plain_kuesioner[0].instrumen_id);
                window.location.href=localStorage.getItem('root_base');
                // window.location.reload(true);
            });
            // alert(event.target.value);
        })
    }

    changeSettingLayout = () => {
        let newSettings = _.set(_.merge({}, this.props.settings), 'layout.config.scroll', 'content');
        setTimeout(() => {
            if(this.props.window_dimension.width <= 425){
                newSettings = _.set(_.merge({}, this.props.settings), 'layout.config.scroll', 'body');
            }
            // console.log(this.props.user.role);
            if ( this.props.user.role === 'guest' ){
                this.props.setDefaultSettings(newSettings);
            }else{
                this.props.updateUserSettings(newSettings);
            }
        }, 2000);
    }

    componentDidMount(){

        if(localStorage.getItem('perlu_reload_lagi') === '1'){
            localStorage.setItem('perlu_reload_lagi', '0');
            setTimeout(() => {
                this.props.setLoadingBesar(true);
                window.location.reload(true);
            }, 1000);
        }

        if(localStorage.getItem('access_token') === '' || localStorage.getItem('access_token') === null){

            fetch(localStorage.getItem('api_domain')+'/api/AuthPengguna?token='+localStorage.getItem('jwt_token'),{
                method: 'GET'
            })
            .then(res => res.json())
            .then(
            (result) => {
                // console.log(result);
                if(typeof(result.user) === 'undefined'){
                    if(localStorage.getItem('access_token') === '' || localStorage.getItem('access_token') === null){
                        this.setState({
                            ...this.state,
                            blocking_login: true
                        })
                    }else{
                        this.setState({
                            ...this.state,
                            namaPengguna: JSON.parse(localStorage.getItem('user')).nama,
                            email: JSON.parse(localStorage.getItem('user')).email,
                            tabValue: window.location.pathname.split('/')[1],
                            routeParams: {
                                ...this.state.routeParams,
                                sekolah_id: JSON.parse( localStorage.getItem('user') ).sekolah_id
                            }
                        },()=>{
        
                            this.props.updateWindowDimension();
                            this.props.getNotifikasiKecil(this.state.routeParams).then((result)=>{
                                // console.log(this.props.notifikasi);
                            });
        
                            window.addEventListener('resize', () => {
                                // alert('tes');
                                this.props.updateWindowDimension();
                                // this.changeSettingLayout();
                                // console.log(this.props.window_dimension);
                            });
        
                            window.addEventListener('scroll', (event) => {
                                // let scrollTop = event.srcElement.body.scrollTop;
                                // console.log(scrollTop);
                            });
        
                            this.props.getPlainKuesioner(this.state.routeParams).then((result)=>{
                                localStorage.setItem('instrumen_id', this.props.plain_kuesioner[0].instrumen_id);            
                                                    
                                // this.changeSettingLayout();
                            });
        
                        });
                    }
                }else{
                    localStorage.setItem('user', JSON.stringify(result.user));
    
                    this.setState({
                        ...this.state,
                        namaPengguna: JSON.parse(localStorage.getItem('user')).nama,
                        email: JSON.parse(localStorage.getItem('user')).email,
                        tabValue: window.location.pathname.split('/')[1],
                        routeParams: {
                            ...this.state.routeParams,
                            sekolah_id: JSON.parse( localStorage.getItem('user') ).sekolah_id
                        }
                    },()=>{
    
                        this.props.updateWindowDimension();
                        this.props.getNotifikasiKecil(this.state.routeParams).then((result)=>{
                            // console.log(this.props.notifikasi);
                        });
    
                        window.addEventListener('resize', () => {
                            // alert('tes');
                            this.props.updateWindowDimension();
                            // this.changeSettingLayout();
                            // console.log(this.props.window_dimension);
                        });
    
                        window.addEventListener('scroll', (event) => {
                            // let scrollTop = event.srcElement.body.scrollTop;
                            // console.log(scrollTop);
                        })
    
                        this.props.getPlainKuesioner(this.state.routeParams).then((result)=>{
                            localStorage.setItem('instrumen_id', this.props.plain_kuesioner[0].instrumen_id);            
                                                
                            // this.changeSettingLayout();
                        });
    
                        // this.setState({
                        //     ...this.state,
                        //     namaPengguna: JSON.parse(localStorage.getItem('user')).nama,
                        //     email: JSON.parse(localStorage.getItem('user')).email,
                        //     tabValue: window.location.pathname.split('/')[1]
                        // });
    
                    });
    
                    // routeParams: {
                    //     ...this.state.routeParams,
                    //     sekolah_id: JSON.parse( localStorage.getItem('user') ).sekolah_id
                    // }
                }
            });

        }

        // console.log(window.location.pathname.split('/')[1]);
        // switch (window.location.pathname.split('/')[1]) {
        //     case value:
                
        //         break;
        
        //     default:
        //         break;
        // }

        // this.setState({
        //     ...this.state,
        //     tabValue: window.location.pathname.split('/')[1]
        // });
        // console.log(this.state.routeParams);

        // this.props.updateWindowDimension();
        // this.props.getNotifikasiKecil(this.state.routeParams).then((result)=>{
        //     console.log(this.props.notifikasi);
        // });

        // window.addEventListener('resize', () => {
        //     // alert('tes');
        //     this.props.updateWindowDimension();
        //     // this.changeSettingLayout();
        //     // console.log(this.props.window_dimension);
        // });

        // window.addEventListener('scroll', (event) => {
        //     let scrollTop = event.srcElement.body.scrollTop;
        //     console.log(scrollTop);
        // })

        // this.props.getPlainKuesioner(this.state.routeParams).then((result)=>{
        //     localStorage.setItem('instrumen_id', this.props.plain_kuesioner[0].instrumen_id);            
                                
        //     // this.changeSettingLayout();
        // });


        
        // console.log(this.props.loading);

        // console.log(this);

        // alert('tes');
        // fetch(localStorage.getItem('api_domain')+'/api/AuthPengguna?token='+localStorage.getItem('jwt_token'),{
        //     method: 'GET'
        //     // headers: {'Content-Type':'application/json'}
        // })
        //   .then(res => res.json())
        //       .then(
        //         (result) => {
        //             // console.log(result.user);
        //             // alert(result.status);

        //             if(result.status == 'Token is Expired' || result.status == 'Authorization Token not found'){
        //                 localStorage.setItem('jwt_token', '');
        //                 localStorage.setItem('user', '');
        //             }else{
        //                 localStorage.setItem('user', JSON.stringify(result.user));

        //             // console.log(localStorage.getItem('user'));                        
        //             }

        //         }
        //       )

        // this.setState({
        //     ...this.state,
        //     namaPengguna: JSON.parse(localStorage.getItem('user')).nama,
        //     email: JSON.parse(localStorage.getItem('user')).email,
        //     tabValue: window.location.pathname.split('/')[1]
        // });
    }

    handleChangeTab = (event, value) => {

        // let route = [
        //     'Beranda',
        //     'PerangkatKuesioner',
        //     'HasilRaporMutu',
        //     'PeringkatPengisian',
        //     'ProfilPengguna'
        // ]

        this.setState({
            tabValue: value
        },()=>{
            history.push("/"+value);
        });
    }

    onClickNotifikasi = (e) => {
        this.setState({
            ...this.state,
            anchorEl: e.target,
            openNotifikasi: true
        })
    }

    handleCloseNotifikasi = () => {
        this.setState({
            ...this.state,
            openNotifikasi: false
        });
    }

    gotoTautan = (tautan) => (e) => {
        history.push(tautan);
    }

    handleClickLogout = (event, data) => {
        // alert('logout');
        localStorage.setItem('jwt_token', '');
        localStorage.setItem('access_token', '');
        localStorage.setItem('user', '');
        localStorage.setItem('pengguna_id_ops', '');
        localStorage.setItem('aslinya_ops', '');

        // // window.location.reload();
        window.location.href="/";
        // if(window.location.pathname.split('/').length === 3){
        //     window.location.href="../"+localStorage.getItem('root_base');
        //     // window.location.reload(true);
        // }else{
        //     // window.location.href=localStorage.getItem('root_base');
        //     // window.location.reload(true);
        // }
    }

    render()
    {
        const {classes, toggleQuickPanel} = this.props;
        // console.log(this.state.tahun);

        return (
            <div 
                className={classNames(classes.root, "flex flex-row mainToolbar")} 
                style={{background: '#ffffff'}}
                // style={{background: '#4EBAE7'}}
                // style={{background: '#E0E0E0'}}
            >
                <Dialog
                    // open={true}
                    open={this.state.blocking_login}
                >
                    <DialogContent id="blocking-login-dialog" style={{textAlign: 'center'}}>
                        Sesi login Anda telah berakhir. Silakan login kembali untuk menggunakan aplikasi
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClickLogout}>Logout</Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.props.loading_besar}
                >
                    <DialogContent id="loading-dialog" style={{textAlign: 'center'}}>
                        <CircularProgress className={classes.progress} style={{height:60, width:60, marginLeft:'20px', marginRight:'20px'}}/>
                        <br/>
                        Memuat...
                    </DialogContent>
                </Dialog>
                <LinearProgress color="primary" className="progresUmum" style={{position: 'fixed', bottom: '0px', left: '0px', width: '100%', height: '10px', display: this.props.loading}}/>
                <BadgeAward jenis_badge_id={9}/>
                <BadgeAward jenis_badge_id={4}/>
                <BadgeAward jenis_badge_id={3}/>
                <BadgeAward jenis_badge_id={2}/>
                <BadgeAward jenis_badge_id={1}/>
                <BadgeAward jenis_badge_id={5}/>
                <BadgeAward jenis_badge_id={6}/>
                <BadgeAward jenis_badge_id={7}/>
                <BadgeAward jenis_badge_id={8}/>
                <Tabs
                    className="tabMobile"
                    value={this.state.tabValue}
                    onChange={this.handleChangeTab}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                    style={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        background: 'white',
                        width: '100%',
                        // borderTop: '1px solid #ccc'
                        boxShadow: '-2px 5px 15px 0px rgba(204,204,204,0.87)'
                    }}
                >
                    <Tab icon={<HomeIcon/>} value="Beranda" label="Beranda" classes={{ root: classes.tabRoot, selected: classes.tabSelected }}/>
                    <Tab icon={<BallotIcon/>} value="PerangkatKuesioner" label="Kuesioner" classes={{ root: classes.tabRoot, selected: classes.tabSelected }}/>
                    {Number(JSON.parse(localStorage.getItem('user')).peran_id) === 10 && <Tab icon={<AutorenewIcon/>} value="HasilRaporMutu" label="Rapor Mutu" classes={{ root: classes.tabRoot, selected: classes.tabSelected }}/>}
                    <Tab icon={<AssignmentTurnedInIcon/>} value="PeringkatPengisian" label="Peringkat" classes={{ root: classes.tabRoot, selected: classes.tabSelected }}/>
                    <Tab icon={<ContactsIcon/>} value="ProfilPengguna" label="Profil" classes={{ root: classes.tabRoot, selected: classes.tabSelected }}/>
                </Tabs>
                <div className="flex flex-1 px-24" style={{paddingLeft:10}}>
                    {/* <Typography style={{color: 'white'}}></Typography> */}
                    {/* <FormControl variant="outlined" className={classes.formControl} style={{width: '100%'}}>
                        <Select
                            value={this.state.tahun}
                            onChange={this.onChangeTahun}
                            // input={
                            // <OutlinedInput
                            //     labelWidth={130}
                            //     name="tahun_ajaran_id"
                            //     id="outlined-tahun_ajaran_id-simple"
                            // />
                            // }
                            style={{color: '#434343'}}
                            
                        >
                            <MenuItem value="2018">Tahun Pendataan 2018</MenuItem>
                            <MenuItem value="2017">Tahun Pendataan 2017</MenuItem>
                        </Select>
                    </FormControl> */}
                    <Typography variant="subheading">
                        {this.props.judul}
                    </Typography>
                </div>

                <div className="flex">
                
                    {/* <div className={classes.seperator} style={{marginTop: '20px'}}/> */}

                    <div className={classes.seperator + " penggunaLengkap"} style={{height:'70px'}} />
                        <div style={{height:'70px', marginTop: '20px'}}>
                            {/* onClick={()=>history.push('/Notifikasi')} */}
                            <StyledBadge className={classes.margin + " penggunaLengkap"} badgeContent={this.props.notifikasi_kecil.total} color="primary">
                            <MenuItem button className="p-8 penggunaLengkap" style={{height:'35px'}} onClick={this.onClickNotifikasi}>
                                <NotificationsIcon/>
                            </MenuItem>
                            </StyledBadge>
                        </div>

                    <div className={classes.seperator + " penggunaLengkap"} style={{height:'70px'}} />

                    <div style={{height:'70px', marginTop: '20px'}}>
                        <MenuItem button className="p-8 penggunaLengkap" style={{height:'35px'}} onClick={() => toggleQuickPanel(true)}>
                            <ListItemAvatar style={{marginRight:5}}>
                                <Avatar alt="Remy Sharp" src={"http://"+window.location.host+"/assets/images/avatars/avatar.gif"} />
                                {/* <Avatar alt="Remy Sharp" src="http://pmp.dikdasmen.kemdikbud.go.id:1745/assets/images/avatars/avatar.gif" /> */}
                            </ListItemAvatar>
                            <ListItemText className="pl-0" primary={<Typography style={{color: '#434343', fontWeight: 'bold'}}>{this.state.namaPengguna}</Typography>} secondary={<Typography style={{color: '#434343'}}>{this.state.email}</Typography>} />
                        </MenuItem>
                    </div>

                    <Menu
                        id="notifikasi-menu"
                        anchorEl={this.state.anchorEl}
                        keepMounted
                        open={this.state.openNotifikasi}
                        // open={this.state.openNotifikasi}
                        onClose={this.handleCloseNotifikasi}
                    >
                        <div style={{width:'400px'}}>
                            {this.props.notifikasi_kecil.rows.map((option)=>{
                                return (
                                    <ListItem onClick={this.gotoTautan(option.tautan)} style={{borderRadius:'0px'}} elevation={0} button className="p-8 border-b-1 border-gray-200">
                                        <Typography variant="caption">
                                            {option.keterangan}
                                            <br/>
                                            <b>{option.create_date}</b>
                                        </Typography>
                                    </ListItem>
                                )
                            })}
                            <MenuItem button className="p-8" onClick={()=>history.push('/Notifikasi')} style={{textAlign:'center', fontStyle: 'italic', background:'#eeeeee', fontSize:'12px'}}>
                                Selengkapnya
                            </MenuItem>
                        </div>
                    </Menu>

                    {/* <div button className="p-8" onClick={() => toggleQuickPanel(true)} style={{cursor: 'pointer'}}>
                        <Avatar
                            alt="foto pengguna" 
                            src="/assets/images/avatars/avatar.gif" 
                            className={classes.avatar}
                        />
                        <Typography variant="subheading" style={{color: 'white'}}>{this.state.namaPengguna}</Typography>
                        <Typography variant="caption" style={{color: 'white'}}>{this.state.email}</Typography>
                    </div> */}

                    {/* <IconButton className="w-64 h-64 penggunaKecil" >
                        <NotificationsIcon/>
                    </IconButton> */}
                    <IconButton className="w-64 h-64 penggunaKecil" onClick={() => toggleQuickPanel(true)}>
                        <Badge className={classes.margin + " penggunaKecil"} badgeContent={this.props.notifikasi_kecil.total} color="primary">
                            <Icon style={{color: '#434343'}}>person</Icon>
                            {/* <Icon style={{color: '#434343'}}>person</Icon> */}
                        </Badge>
                    </IconButton>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        toggleQuickPanel: quickPanelActions.toggleQuickPanel,
        getPlainKuesioner: Actions.getPlainKuesioner,
        updateWindowDimension: Actions.updateWindowDimension,
        setDefaultSettings: Actions.setDefaultSettings,
        updateUserSettings: AuthActions.updateUserSettings,
        setLoadingBesar: Actions.setLoadingBesar,
        getNotifikasi: Actions.getNotifikasi,
        getNotifikasiKecil: Actions.getNotifikasiKecil,
    }, dispatch);
}

function mapStateToProps({ App, Instrumen, fuse, auth }) {

    return {
        loading: App.loading,
        loading_besar: App.loading_besar,
        plain_kuesioner: Instrumen.plain_kuesioner,
        settings: fuse.settings.current,
        user    : auth.user,
        window_dimension: App.window_dimension,
        judul: App.judul,
        notifikasi: App.notifikasi,
        notifikasi_kecil: App.notifikasi_kecil
    }
}

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(MainToolbar));



// WEBPACK FOOTER //
// ./src/main/MainToolbar.js